const dateToString = require("./dateFormatter");
const { getLanguage } = require("../../entryPoints/layout/js/multilanguage");
const PayModal = require("../announcement/PayModal");

let pm = new PayModal("payModal");

const dramIcon = `<svg title="դրամ" class="cur-icon cur-icon-right"><use xlink:href="#dram"></use></svg>`
const rubleIcon = `<svg title="ռուբլի" class="cur-icon cur-icon-right"><use xlink:href="#ruble"></use></svg>`
const dolarIcon = `<svg title="դոլլար" class="cur-icon cur-icon-left cur-icon-dollar"><use xlink:href="#dollar"></use></svg>`
const euroIcon = `<svg title="եվրո" class="cur-icon cur-icon-left"><use xlink:href="#euro"></use></svg>`

class Template {
  constructor(announcement, model, cities = [], moreButton = true) {
    this.id = announcement.id;
    this.model = model;
    this.cities = cities;
    this.moreButton = moreButton;
    this.announcement = announcement;
    this.planeIcon = false;

    this.fromCity = model.travelData.fromCity;
    this.toCity = model.travelData.toCity;
    this.departureDate = new Date(model.travelData.departureDate);
    this.arrivalDate = new Date(model.travelData.arrivalDate);
    this.transits = model.travelData.transits;
    this.goods = model.travelData.goods;
    let translationsJSON = document.getElementById("Translations").innerHTML;
    this.translations = JSON.parse(translationsJSON);

    this.transportIcons = [
      "human",
      "bicycle",
      "motorcycle",
      "car",
      "truck",
      "van",
      "bus",
      "train",
      "ship",
      "helicopter",
      "plane",
    ];
  }

  getCityNameById(id) {
    let lang = getLanguage();
    let city = null;

    this.cities[lang].forEach((ct) => {
      if (ct.id === id || ct.placeId === id) city = ct;
    });

    return city ? city.formatted_address : null;
  }

  get title() {
    debugger
    let citiesNames = [];
    let lang = getLanguage();

    this.cities[lang].forEach(ct => {
      citiesNames.push(ct.name);
    });

    let goodNames = new Set();

    let descriptions = this.translations.goodTypeTitles;

    this.model.travelData.goods.forEach((gd) => {
      goodNames.add(descriptions[gd.goodType - 1]);
    });

    goodNames = [...goodNames];

    let key = this.announcement._type === 1 ? 'get-announcement-title' : 'get-send-announcement-title';

    return (
      this.translations[key] +
      ` › ${citiesNames.join(" - ")} › ${goodNames.join(", ").toLowerCase()}`
    );
  }

  get isOwner() {
    return location.search.includes("accessCode");
  }

  get picturePath() {
    let d = new Date(this.announcement.createdAt);
    return `/ogPics/${d.getFullYear()}-${d.getMonth()}/${
      this.announcement.id
    }-thumb.png`;
  }

  renderPath() {
    let mainTransportTypeIcon = "";
    if (this.model.travelData.transportType > 0)
      mainTransportTypeIcon = this.transportIcons[
        this.model.travelData.transportType - 1
      ];

    let html = `<li>
                        <div class="path-cont">
                            <div class="path-line">
                                    ${
                                      mainTransportTypeIcon === ""
                                        ? '<i class="fa fa-chevron-right"></i>'
                                        : '<svg class="trans-icon"><use xlink:href="#' +
                                          mainTransportTypeIcon +
                                          '"></use></svg>'
                                    }
                             </div>
                            <div class="path-desc">
                                <div>${this.getCityNameById(
                                  this.fromCity.id
                                )}</div>
                                ${
                                  this.announcement._type === 1
                                    ? "<span>" +
                                      dateToString(this.departureDate) +
                                      "</span>"
                                    : ""
                                }
                            </div>
                        </div>
                    </li>`;

    let trs = [];

    if (this.transits.length >= 2 && (this.transits.length - 2) % 3 === 0) {
      for (let i = 0; i < this.transits.length; i++) {
        let tr = this.transits[i];
        trs.push(tr);

        if (trs.length == 2) {
          trs.push(tr);
        }
      }
    } else {
      trs = this.transits;
    }

    trs.forEach((tr) => {
      let transportIcon = this.transportIcons[tr.transportType - 1];
      html += `<li>
                          <div class="path-cont">
                            <div class="path-line"><svg class="trans-icon"><use xlink:href="#${transportIcon}"></use></svg></div>
                            <div class="path-desc">
                              <div>${this.getCityNameById(tr.city.id)}</div>
                              <span>${dateToString(
                                new Date(tr.arrivalDate),
                                this.announcement._type === 1
                              )}</span></div>
                          </div>
                      </li>`;
    });

    html += `<li>
                    <div class="path-cont">
                        <div class="path-line"></div>
                        <div class="path-desc">
                            <div> ${this.getCityNameById(this.toCity.id)} </div>
                            <span> ${dateToString(
                              this.arrivalDate,
                              this.announcement._type === 1
                            )} </span></div>
                    </div>
                 </li>`;

    return html;
  }

  renderLuggage() {
    let html = "";

    let descriptions = this.translations.goodTypeTitles;
    let quantityLabels = this.translations["can-take-good-quantity"].split(",");
    let prices = document.getElementById("Prices").innerHTML;
    prices = JSON.parse(prices);

    const itemRenderer = (gd) => {
      let type = gd.goodType - 1;
      let desc = descriptions[type];

      let priceString = "";
      let price = gd.price;

      if (price > 0 && price < 1000000) {
        if (price >= 1000) price = (price / 1000).toFixed(3);

        switch(gd.currency) {
          case 1:
            priceString = `<span>${price}</span>${dramIcon}`;
          break;
          case 2:
            priceString = `<span>${price}</span>${rubleIcon}`;
          break;
          case 3:
            priceString = `${dolarIcon}<span>${price}</span>`;
          break;
          case 4:
            priceString = `${euroIcon}<span>${price}</span>`;
          break;
        }
      } else {
        priceString = this.translations["by-agreement-input-label"];
      }

      let quantity = gd.quantity;

      let label = "";

      let types1 = [1, 2];
      let types2 = [4, 5];
      let types3 = [6, 7, 8, 9];

      if (types1.includes(gd.goodType)) label = quantityLabels[0];
      if (types2.includes(gd.goodType)) label = quantityLabels[1];
      if (gd.goodType === 3) label = quantityLabels[2];
      if (types3.includes(gd.goodType)) label = quantityLabels[3];

      let lang = getLanguage();

      let until = {
        am: "մինչև",
        ru: "до",
        en: "untill",
      };

      html += `
                <li>
                    <i class="fa fa-check"></i>
                    <span class="luggage-text">${desc} (${
        quantity == 1 ? "" : until[lang] + " "
      }${quantity} ${label})${
        lang === "am" ? "՝" : ":"
      }</span><span class="luggage-price">${priceString}<span class="per">/${this.translations[`price-input-label-type-${gd.goodType}`]}</span></span>
      
                </li>
            `;
    };

    let lang = getLanguage();

    const humans = this.goods.filter((gd) => gd.goodType > 5);
    const goods = this.goods.filter((gd) => gd.goodType <= 5);

    if (goods.length > 0)
      html += `<li><span class="luggage-section">${this.translations["goods-subsection-title-items"]}${lang === "am" ? "՝" : ":"} </span></li>`;
    goods.forEach(itemRenderer);

    if (humans.length > 0)
      html += `<li><span class="luggage-section">${this.translations["goods-subsection-title-humans"]}${lang === "am" ? "՝" : ":"} </span></li>`;
    humans.forEach(itemRenderer);

    return html;
  }

  render() {
    let luggageTitleSend = document.getElementById("searchItemLuggageTitleSend")
      .innerHTML;
    let luggageTitleDeliver = document.getElementById(
      "searchItemLuggageTitleDeliver"
    ).innerHTML;

    let paymentDescription = document.getElementById(
      "searchItemPaymentDescription"
    ).innerHTML;
    let pointsCount = this.transits.length + 2;

    let lang = getLanguage();
    let type = this.announcement._type === 1 ? "deliver" : "send";

    let typeNames = [
      document.getElementById("annTypeTitle1").innerHTML,
      document.getElementById("annTypeTitle2").innerHTML,
    ];

    return `
            <li id="ann-item-${this.id}">
                <section class="container">
                    ${this.planeIcon ? `<div class="plane"></div>` : ""}
                    <div class="offer-image"><img src="${
                      this.picturePath
                    }" alt=""></div>

                    <div class="path-desc counters">
                        <span>
                          <div title="Դիտումներ"><i class="fa fa-eye" aria-hidden="true"></i> ${
                            this.announcement.viewCount
                          } </div>
                          <div title="Դիմողներ"><i class="fa fa-phone" aria-hidden="true"></i> ${
                            this.announcement.paymentCount
                          } </div>
                        </span>
                    </div>
                    
                    <div class="path-desc type-${type}"><span>${
      typeNames[this.announcement._type - 1]
    }</span></div>

                    <ul class="path point-${pointsCount}">
                        ${this.renderPath()}
                    </ul>
                    ${
                      this.announcement._type === 1
                        ? luggageTitleDeliver
                        : luggageTitleSend
                    }
                    <ul class="luggage-cont">
                        ${this.renderLuggage()}
                    </ul>
                    <hr>
                    <div class="get-number form-floor-last" ${
                      this.isOwner ? `style="visibility: hidden"` : ""
                    } >
                        ${
                          this.moreButton
                            ? `<a href="${
                                lang +
                                "/announcement/" +
                                this.announcement.publicID
                              }" class="button-link round-button" title="Ավելին"><i class="fa fa-chevron-right"></i></a>`
                            : ""
                        }
                        <button type="button" class="round-button" title="${
                          this.translations["search-item-payment-description"]
                        }" data-id="${
      this.id
    }"><i class="fa fa-phone"></i></button>
                        ${paymentDescription}
                    </div>
                    <div class="share-number">
                        <div class="addthis_toolbox addthis_default_style addthis_32x32_style" addthis:url="https://class.am/${lang}/announcement/${
      this.announcement.publicID
    }" addthis:title="${this.title}"> <a class="addthis_button_facebook" title="Facebook"></a> <a class="addthis_button_vk" title="VKontakte"></a> <a class="addthis_button_odnoklassniki_ru" title="Odnoklassniki"></a> <a class="addthis_button_messenger" title="Messenger"></a> <a class="addthis_button_whatsapp" title="WhatsApp"></a> <a class="addthis_button_viber" title="Viber"></a> <a class="addthis_button_telegram" title="Telegram"></a> <a class="addthis_button_skype" title="Skype"></a> <a class="addthis_button_compact"></a> </div>
                    </div>
                </section>
            </li>
        `;
  }

  initEvents() {
    let elem = document.querySelector(
      `#ann-item-${this.id} .round-button[data-id]`
    );

    elem.addEventListener("click", () => {
      let id = elem.getAttribute("data-id");

      pm.open(id);
    });

    let container = document.querySelector(`#announcementBody`);
    if (container) {
      let contactAccess =
        container.getAttribute("data-contact-access") === "true";

      if (contactAccess) {
        window.$(elem).hide();
        window.$(".form-desc-last span").hide();
      }
    }
  }
}

module.exports = Template;
